// extracted by mini-css-extract-plugin
export default {"wrapper":"Tda-z","play":"Uda-z"};